import {Drawer} from '@ark-ui/react/drawer'
import styles from './drawer.module.css'
import {createOverlay} from '@chakra-ui/react'

export const swipeableDrawer = createOverlay<Drawer.RootProps>(props => {
  const {children, open, onOpenChange, id, ...rest} = props
  return (
    <Drawer.Root
      {...rest}
      open={open}
      unmountOnExit
      lazyMount
      onOpenChange={onOpenChange}
      id={id}
      snapPoints={[0.25, 0.5, 1]}
      defaultSnapPoint={0.25}
    >
      <Drawer.Backdrop className={styles.Backdrop} />
      <Drawer.Positioner className={styles.Positioner}>
        <Drawer.Content className={styles.Content}>
          <Drawer.Grabber className={styles.Grabber}>
            <Drawer.GrabberIndicator className={styles.GrabberIndicator} />
          </Drawer.Grabber>
          {children}
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  )
})
